module.exports = __webpack_public_path__ + "img/preco_titular2.9f45bed8.png";